import React, { useRef } from 'react';

import styles from './LongText.module.scss';
import { useAutosizeTextArea } from '../../../hooks/useAutosizeTextArea';

interface AutoResizeLongTextProps {
    value: string;
    updateValue: (value: string) => void;
    testId?: string;
    className?: string;
    maxLength?: number
}

export const AutoResizeLongText: React.FC<AutoResizeLongTextProps> = ({ value, updateValue, testId, className = styles.autoResizeLongText, maxLength }) => {
    const textAreaRef = useRef<HTMLTextAreaElement>(null);

    useAutosizeTextArea(textAreaRef.current, value);
    return (
        <textarea
            className={className}
            value={value}
            onChange={e => updateValue(e.target.value)}
            data-testid={`auto-resize-longtext-${testId}`}
            ref={textAreaRef}
            maxLength={maxLength}
        />
    );
};
